export default {
  value: {
    type: 'number',
    required: true,
  },
  comment: {
    type: 'string',
    required: false,
  },
  timestamp: {
    type: 'date',
    required: false,
  },
};
